<template>
    <div class="safety-table">
        <a-empty
            v-if="!loading && hasError"
        >
            <template #image>
                <security-scan-outlined
                    style="font-size: 64px; color: #d9d9d9;"
                />
            </template>
            <template #description>
                Нет данных
            </template>
        </a-empty>
        <a-table
            v-else
            :columns="columns"
            :data-source="devices"
            :pagination="false"
            :loading="loading"
            size="small"
            row-key="id"
        >
            <template #deviceId="{ record }">
                {{ formatDeviceId(record.deviceId) }}
            </template>
            <template #os="{ record }">
                {{
                    record.os
                        ? `${record.os}${
                            record.deviceId && record.deviceId === currentDeviceId
                                ? ' (это вы)'
                                : ''
                        }`
                        : '-'
                }}
            </template>
            <template #browser="{ record }">
                {{ record.browser || '-' }}
            </template>
            <template #createdAt="{ record }">
                {{ formatDate(record.createdAt) }}
            </template>
            <template #updatedAt="{ record }">
                {{ formatDate(record.updatedAt) }}
            </template>
            <template #ip="{ record }">
                {{ record.ip || '-' }}
            </template>
            <template #action="{ record }">
                <a-button
                    class="logout-btn"
                    @click="onLogoutClick(record)"
                >
                    Выйти
                </a-button>
            </template>
        </a-table>

        <!-- Модальное окно Warning -->
        <a-modal
            v-model:visible="isWarningModalVisible"
            :footer="null"
            :mask-closable="false"
            :closable="false"
            :width="null"
            wrap-class-name="warning-modal-wrapper"
            centered
        >
            <safety-warning
                v-if="isWarningModalVisible"
                :user-id="selectedRecord?.userId"
                :device-id="selectedRecord?.deviceId"
                @close="onWarningClose"
                @table-update="onTableUpdate"
            />
        </a-modal>
    </div>
</template>

<script>
import moment from 'moment';
import { Empty as AEmpty } from 'ant-design-vue';
import SecurityScanOutlined from '@ant-design/icons-vue/SecurityScanOutlined';
import SafetyWarning from '@/components/safety/Warning.vue';
import { sseService } from '@/utils';

export default {
    name: 'SafetyTable',
    components: {
        SafetyWarning,
        SecurityScanOutlined,
        AEmpty,
    },
    data() {
        return {
            loading: false,
            isWarningModalVisible: false,
            selectedRecord: null,
            hasError: false,
            currentDeviceId: null,
            columns: [
                {
                    title: 'Устройство',
                    dataIndex: 'os',
                    key: 'os',
                    slots: { customRender: 'os' },
                },
                {
                    title: 'Браузер',
                    dataIndex: 'browser',
                    key: 'browser',
                    slots: { customRender: 'browser' },
                },
                {
                    title: 'Device-id',
                    dataIndex: 'deviceId',
                    key: 'deviceId',
                    slots: { customRender: 'deviceId' },
                },
                {
                    title: 'Первая активация',
                    dataIndex: 'createdAt',
                    key: 'createdAt',
                    slots: { customRender: 'createdAt' },
                },
                {
                    title: 'Последний вход',
                    dataIndex: 'updatedAt',
                    key: 'updatedAt',
                    slots: { customRender: 'updatedAt' },
                },
                {
                    title: 'IP-адрес',
                    dataIndex: 'ip',
                    key: 'ip',
                    slots: { customRender: 'ip' },
                },
                {
                    key: 'action',
                    slots: { customRender: 'action' },
                },
            ],
            devices: [],
            unsubscribeNotification: null,
        };
    },
    created() {
        this.currentDeviceId = localStorage.deviceId || null;
        this.fetchDevices();

        this.unsubscribeNotification = sseService.subscribe(
            'notification',
            this.onSseNotification,
        );
    },
    beforeUnmount() {
        if (typeof this.unsubscribeNotification === 'function') {
            this.unsubscribeNotification();
        }
        this.unsubscribeNotification = null;
    },
    methods: {
        async fetchDevices() {
            const userId = localStorage.staffId;
            if (!userId) {
                this.hasError = true;
                return;
            }

            this.loading = true;
            this.hasError = false;

            try {
                const response = await this.$http.get(`/user/${userId}/device`);
                if (response.data?.success && response.data?.devices?.data) {
                    this.devices = response.data.devices.data;
                } else {
                    this.devices = [];
                }
            } catch (error) {
                this.hasError = true;
                this.devices = [];
            } finally {
                this.loading = false;
            }
        },
        formatDate(dateString) {
            if (!dateString) {
                return '-';
            }
            return moment(dateString).format('DD.MM.YYYY в HH:mm');
        },
        formatDeviceId(deviceId) {
            if (!deviceId) {
                return '-';
            }
            if (deviceId.length <= 7) {
                return deviceId;
            }
            return `${deviceId.substring(0, 7)}...`;
        },
        onLogoutClick(record) {
            this.selectedRecord = record;
            this.isWarningModalVisible = true;
        },
        onWarningClose() {
            this.isWarningModalVisible = false;
            this.selectedRecord = null;
        },
        onTableUpdate() {
            this.fetchDevices();
        },
        onSseNotification() {
            this.fetchDevices();
        },
    },
};
</script>

<style scoped lang="scss">
.safety-table {
    :deep(.ant-table) {
        .ant-table-thead > tr > th {
            background-color: #f5f5f5;
            font-weight: 500;
        }

        .ant-table-tbody > tr > td {
            border-bottom: 1px solid #f0f0f0;
        }
    }

    .logout-btn {
        background-color: #f7967e;
        border: none;
        color: #fff;
        border-radius: 4px;
        padding: 4px 15px;
        font-size: 14px;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover {
            background-color: #e8856d;
        }
    }
}
</style>

<style lang="scss">
.warning-modal-wrapper {
    .ant-modal {
        max-width: fit-content;
        padding-bottom: 0;
    }

    .ant-modal-content {
        padding: 0;
    }

    .ant-modal-body {
        padding: 0;
    }
}
</style>
